// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Modal_closeButton__066hL","popup":"Modal_popup__UjghJ","menu":"Modal_menu__WQ_8a","fadeIn":"Modal_fadeIn__wKLG3","spin":"Modal_spin__meATe"};